import { baseUrl } from '@/service/util';
import request from '@/utils/request';
import { setLocaleQuery } from '@/utils';

export const postImgAndPDF = (data: any, locale: string) => {
    return request(`${baseUrl(locale)}/productQuote/updateDp3${setLocaleQuery(locale)}`, {
        method: 'post',
        data,
        // needToken: true,
    });
};

// 报价单提交表单
export const submitForm = (data: any, locale: string) => {
    return request(`${baseUrl(locale)}/productQuote/saveDp3${setLocaleQuery(locale)}`, {
        method: 'post',
        data,
        // needToken: true,
    });
};
